import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { LINK_SAVED_REPLIES_GUIDE } from 'shared/constants/links'
import { uiStore } from 'shared/store/uiStore'
import { SavedRepliesPath } from 'pages/settings/pages/savedReplies/route/savedRepliesPath'
import { useSavedRepliesContext } from 'pages/settings/pages/savedReplies/context/savedRepliesContext'

import styles from './styles.module.scss'

export const CreateSavedRepliesButton = observer(({ disabled }: { disabled?: boolean }) => {
  const {
    newSavedReplyStore,
    setShowCreateContent,
    canManageSavedReplies,
    savedRepliesPermissionError,
  } = useSavedRepliesContext()

  const handleCreate = () => {
    newSavedReplyStore.handleNewSavedReply()
    setShowCreateContent(true)
    uiStore.changeRoute({
      path: SavedRepliesPath.create,
    })
  }

  return (
    <Button
      text='New reply'
      size='medium'
      iconProps={{ icon: 'add' }}
      onClick={handleCreate}
      className={styles.createButton}
      disabled={disabled || !canManageSavedReplies}
      tooltipProps={{
        label: savedRepliesPermissionError,
        placement: 'top',
      }}
    />
  )
})

export const GuideSavedRepliesButton = observer(({ className }: { className?: string }) => (
  <Button
    className={className}
    tag={'a'}
    href={LINK_SAVED_REPLIES_GUIDE}
    text='Help guide'
    target='_blank'
    rel='noreferrer'
    size='medium'
    contained='secondary'
    iconProps={{ icon: 'info' }}
  />
))
